import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnitUtilsService {
  private readonly BINARY_METADATA_UNIT_NAMES = new Set(['On/Off', 'Dirty/Clean', 'Auto/Manual', 'Day/Night', 'Fault/Normal', 'Normal/Fault', 'Flow/No Flow', 'Open/Closed']);

  constructor() {}

  isFloat(n): boolean {
    return n % 1 !== 0;
  }

  parseNumber(num: any, places: number): number {
    if (!isNaN(num)) {
      if (this.isFloat(num)) {
        num = num / 1;
        return Number(num.toFixed(places));
      } else {
        return num;
      }
    } else {
      return num;
    }
  }

  isBinaryUnit(unitName: string): boolean {
    return this.BINARY_METADATA_UNIT_NAMES.has(unitName);
  }
}
